import { useSelector } from "react-redux";
import {
  DMAutomationPlatform,
  DMAutomationTrigger,
} from "@markit/common.types";
import {
  GetDateWithTime,
  getDMAutomationTriggerTitle,
} from "@markit/common.utils";
import { getAccountSlice } from "../../../../redux/slices/accountSlice";
import {
  getKeywordTriggerLabel,
  getTriggerPostLabel,
} from "../../../../utils/dmAutomationUtils";
import { SocialPlatformThumbnailItem } from "../../../DisplayItem/AutoDM/SocialPlatformThumbnailItem";
import { useMemo } from "react";

type DMAutomationTriggerPreviewProps = {
  trigger: DMAutomationTrigger;
  platform: DMAutomationPlatform;
  iconSize?: number;
};

// Displays trigger icon, title, account, date, and keywords/replies.
const DMAutomationTriggerPreview = (props: DMAutomationTriggerPreviewProps) => {
  const { trigger, platform, iconSize = 38 } = props;
  const { instagramAccounts, facebookPages } = useSelector(getAccountSlice);

  const accountLabel = useMemo(
    () =>
      platform === DMAutomationPlatform.FACEBOOK
        ? facebookPages.find((page) => page.id === trigger.igAccountId)
            ?.pageName
        : instagramAccounts.find(
            (account) => account.id === trigger.igAccountId
          )?.username,
    [facebookPages, instagramAccounts, platform, trigger.igAccountId]
  );

  const triggerTitle = useMemo(
    () =>
      `${getTriggerPostLabel(trigger)} · ${getKeywordTriggerLabel(
        trigger.keywordRules ?? [],
        trigger
      )}`,
    [trigger]
  );

  return (
    <div className="AlignedRow" style={{ gap: 10 }}>
      <SocialPlatformThumbnailItem
        mediaUrl={trigger.mediaUrl}
        size={iconSize}
        platform={platform}
      />
      <div className="ColumnNormal" style={{ gap: 4 }}>
        <span className="bodyMedium">
          {getDMAutomationTriggerTitle(trigger)}
        </span>
        <div className="AlignedRow" style={{ gap: 4, flexWrap: "wrap" }}>
          <span className="bodySmallMedium">
            {accountLabel ? `@${accountLabel}` : "No Connected Account"}
          </span>
          <span className="smallBodySubtext">
            {GetDateWithTime(trigger.createdAt, true)}
          </span>
        </div>
        <span className="smallBodySubtext TwoLineText">{triggerTitle}</span>
      </div>
    </div>
  );
};

export default DMAutomationTriggerPreview;
